import React, { useEffect } from "react";

import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";
import { withReport } from "../../../shared/containers/containerReport";
import { withUnitReport } from "../../../shared/containers/containerUnitReport";
import { withReportTime } from "../../../shared/containers/containerReportTime";
import ContentInnerWrapper from "./../../../shared/contentInnerWrapper";

const deleteReport = (props, reportId) => {
  const { selectedReports, onSelectReport } = props;
  let updatedReports = [...selectedReports];
  let reportIndex = selectedReports.findIndex((item) => item.id === reportId);
  updatedReports.splice(reportIndex, 1);

  onSelectReport(updatedReports);
};

const handleChangeReport = (props, report) => {
  const { onСhangeReport, onChangeTimeReport, reportStartDate, reportEndDate, selectedReports } = props;
  const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

  const title = report.title;
  const id = report.id;
  const type = report.reportType;

  if (report.requestInerval === 1) {
    onChangeTimeReport("reportStartTime", reportStartDate);

    const end = new Date(reportEndDate.getTime());

    if (!isDayInterval) {
      end.setHours(23);
      end.setMinutes(59);
      end.setSeconds(59);
    } else {
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
    }

    onChangeTimeReport("reportEndTime", end);
  }

  onСhangeReport(title, id, type);
};

const SelectedReportsList = (props) => {
  const { selectedReports, reportId, onClearReport, title } = props;

  useEffect(() => {
    if (selectedReports.length > 0) {
      handleChangeReport(props, selectedReports[0]);
    } else {
      onClearReport();
    }
  }, [selectedReports]);

  if (selectedReports.length === 0) {
    return null;
  }

  return <ContentInnerWrapper title={title} />;
};

export default withReportTime(withUnitReport(withReport(withSelectedReports(React.memo(SelectedReportsList)))));
